import * as React from 'react';
import { Search } from "../Search/Search";
import { MiniFilter } from './MiniFilter/MiniFilter';
import { safe, addItemToGoogleTracking } from "../../utils";
import { IPageProperties, ISearch } from "../../models";
import { camelCase } from "change-case";

const styles = require('./styles.pcss');
const minisearchBarStyles = require('./overrides/miniSearch.pcss');
const minisearchFilterStyles = require('./overrides/miniFilter.pcss');
let FaAngleRight = require('react-icons/lib/fa/angle-right');

interface IState {
    assetClass?: string;
    assetClassData?: string[]
    fundName?: string;
    fundNameData?: string[];
    shareclassLetter?: string;
    shareclassLetterData?: string[];
    searchTerm?: string;
}

export class MiniFundFinder extends React.Component<IPageProperties, IState>{
    constructor(props) {
        super(props);
        this.state = {
            assetClass: "",
            assetClassData: [],
            fundName: "",
            fundNameData: [],
            shareclassLetter: "",
            shareclassLetterData: [],
            searchTerm: ""
        };

        this.setFilter = this.setFilter.bind(this);
        this.setSearchTerm = this.setSearchTerm.bind(this);
        this.getFilterURL = this.getFilterURL.bind(this);
    }

    setSearchTerm(term) {
        this.setState({ searchTerm: term });
    }

    setFilter(type, value) {
        let { appParams } = this.props;
        let { assetClass, fundName, shareclassLetter, assetClassData } = this.state;
        let newState = {
            assetClass: assetClass,
            assetClassData: assetClassData,
            fundName: fundName,
            fundNameData: [],
            shareclassLetter: shareclassLetter,
            shareclassLetterData: []
        };

        newState[camelCase(type)] = value;

        if (type === "asset_class") {
            addItemToGoogleTracking(appParams, "find_your_fund_asset_class", { eventCategory: value });
            newState.fundName = "";
            newState.shareclassLetter = "";
            newState.fundNameData = this.getFilteredDropdownValues("fund_name", "asset_class", value);
            newState.shareclassLetterData = this.getFilteredDropdownValues("shareclass_letter", "asset_class", value);
        }

        if (type === "fund_name") {
            addItemToGoogleTracking(appParams, "find_your_fund_fund_name", { eventCategory: value });
            newState.shareclassLetter = "";
            newState.fundNameData = this.state.fundNameData;
            newState.shareclassLetterData = this.getFilteredDropdownValues("shareclass_letter", "fund_name", value);
        }

        if (type === "shareclass_letter") {
            addItemToGoogleTracking(appParams, "find_your_fund_share_class", { eventCategory: value });
            newState.fundNameData = this.state.fundNameData;
            newState.shareclassLetterData = this.state.shareclassLetterData;
        }

        this.setState(newState);
    }

    getFilteredDropdownValues(type, filterType, filterValue) {
        let { typeahead } = this.props;
        let result: string[] = [];

        for (let item of typeahead) {
            if (result.indexOf(item.display[type] as string) === -1 && item.display[filterType] === filterValue) {
                result.push(item.display[type] as string);
            }
        }
        return result;
    }

    setInitialDropdownValues(type) {
        let { typeahead } = this.props;
        let result: string[] = [];

        for (let item of typeahead) {
            if (result.indexOf(item.display[type] as string) === -1) {
                result.push(item.display[type] as string);
            }
        }

        this.setState({ [`${camelCase(type)}Data`]: result });
    }

    componentDidMount() {
        this.setInitialDropdownValues("asset_class");
        this.setInitialDropdownValues("shareclass_letter");
        this.setInitialDropdownValues("fund_name");
    }

    getFilterURL() {
        let { assetClass, fundName, shareclassLetter } = this.state;
        let { appParams } = this.props;

        let explorerURL = `${ appParams.baseurl }${ appParams.fundExplorerUrl }`;
        let queryCollection = [];

        if (assetClass !== "") {
            queryCollection.push(`asset_class=${ encodeURIComponent(assetClass) }`);
        }
        if (fundName !== "") {
            queryCollection.push(`fund_name=${ encodeURIComponent(fundName) }`);
        }
        if (shareclassLetter !== "") {
            queryCollection.push(`shareclass_letter=${ encodeURIComponent(shareclassLetter) }`);
        }

        if (queryCollection.length > 0) {
            window.location.href = `${ explorerURL }${ process.env.NODE_ENV === "local" ? `/${ appParams.productrange }/${ appParams.region }/${ appParams.clienttype }/${ appParams.language }` : "" }?${ queryCollection.join("&") }`;
        } else if (this.state.searchTerm !== "") {
            window.location.href = `${ explorerURL }${ process.env.NODE_ENV === "local" ? `/${ appParams.productrange }/${ appParams.region }/${ appParams.clienttype }/${ appParams.language }` : "" }?term=${ encodeURIComponent(this.state.searchTerm) }&type=match`;
        } else {
            window.location.href = `${ explorerURL }${ process.env.NODE_ENV === "local" ? `/${ appParams.productrange }/${ appParams.region }/${ appParams.clienttype }/${ appParams.language }` : "" }`;
        }
    }

    render() {
        let { funds, filterOptions, changeFilter, filter, appParams, typeahead } = this.props;
        let { assetClassData, assetClass, shareclassLetterData, shareclassLetter, fundNameData, fundName } = this.state;
        let search: ISearch[] = []
        if (assetClass !== "") {
            search.push({
                property: "asset_class",
                matchtype: "MATCH",
                values: [assetClass]
            });
        }
        if (shareclassLetter !== "") {
            search.push({
                property: "shareclass_letter",
                matchtype: "MATCH",
                values: [shareclassLetter]
            });
        }
        if (fundName !== "") {
            search.push({
                property: "fund_name",
                matchtype: "MATCH",
                values: [fundName]
            });
        }

        return (
            <div className={styles.miniFundfinder}>
                <div className={styles.header}><h4>Fund finder</h4></div>
                <div className={styles.content}>
                    <div className={styles.row + ' ' + "MiniFundFinder_search"}>
                        <Search
                            miniFinderSearch={search}
                            filterOptions={filterOptions}
                            changeFilter={changeFilter}
                            appParams={appParams}
                            filter={filter}
                            typeahead={typeahead}
                            isFundPage={false}
                            isMiniFinder={ true }
                            setTermFn={ this.setSearchTerm }
                            styles={minisearchBarStyles} />
                    </div>
                    <div className={styles.fundResult}>
                        <p className={styles.shareClassTotal}>{funds.shareClassTotal} Share classes available</p>
                    </div>
                    <div className={styles.filters + ' ' + "MiniFundFinder_filters"}>
                        <div className={styles.filterDropdown + ' ' + "MiniFundFinder_filterDropdown"}>
                            <MiniFilter
                                filterData={assetClassData}
                                selectedItem={assetClass}
                                selectFn={this.setFilter}
                                type={'asset_class'}
                                appParams={appParams}
                                styles={minisearchFilterStyles}
                            />
                        </div>
                        <div className={styles.filterDropdown + ' ' + "MiniFundFinder_filterDropdown"}>
                            <MiniFilter
                                filterData={fundNameData}
                                selectedItem={fundName}
                                selectFn={this.setFilter}
                                type={'fund_name'}
                                appParams={appParams}
                                styles={minisearchFilterStyles}
                            />
                        </div>
                        <div className={styles.filterDropdown + ' ' + "MiniFundFinder_filterDropdown"}>
                            <MiniFilter
                                filterData={shareclassLetterData}
                                selectedItem={shareclassLetter}
                                selectFn={this.setFilter}
                                type={'shareclass_letter'}
                                appParams={appParams}
                                styles={minisearchFilterStyles}
                            />
                        </div>
                    </div>
                    <div className={styles.fundActions}>
                        <div className={styles.viewFundsLink}>
                            <a onClick={ () => addItemToGoogleTracking(appParams, "find_your_fund_view_all_funds_cta", {})} href={`${appParams.baseurl}${appParams.fundExplorerUrl}`}>
                                View all funds <FaAngleRight style={{ marginTop: "-3px" }} />
                            </a>
                        </div>
                        <button onClick={ this.getFilterURL } type="button" className={ styles.tabButtons }>
                            Find funds {/*<span>{ funds.shareClassTotal }</span>*/ }<FaAngleRight style={ { marginTop: "-3px" } } />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/MiniFundFinder/index.tsx